import { HttpClient } from 'api/http-client';

class ViewFiltersAPIClient extends HttpClient {
  public async getViewFilters(): Promise<any> {
    return this.get<any>('/scarlet/view-filters');
  }

  public async saveViewFilter(payload: any): Promise<any> {
    return this.post('/scarlet/view-filters', payload);
  }

  public async updateViewFilter(payload: any): Promise<any> {
    return this.put(`/scarlet/view-filters/${payload.viewId}`, payload);
  }
}

export const ViewFiltersAPI = new ViewFiltersAPIClient();
